export const NOTE_COLORS = {
  AMARELO: {
    label: "Amarelo",
    swatch: "bg-amber-200",
    card: "border-amber-300/30 bg-amber-200/90",
    text: "text-amber-950",
    soft: "text-amber-900/70",
  },
  AZUL: {
    label: "Azul",
    swatch: "bg-sky-200",
    card: "border-sky-300/30 bg-sky-200/90",
    text: "text-sky-950",
    soft: "text-sky-900/70",
  },
  ROSA: {
    label: "Rosa",
    swatch: "bg-pink-200",
    card: "border-pink-300/30 bg-pink-200/90",
    text: "text-pink-950",
    soft: "text-pink-900/70",
  },
  VERDE: {
    label: "Verde",
    swatch: "bg-emerald-200",
    card: "border-emerald-300/30 bg-emerald-200/90",
    text: "text-emerald-950",
    soft: "text-emerald-900/70",
  },
};

export const COLUMNS = [
  { id: "NOVOS", label: "Novos", dot: "bg-sky-400" },
  { id: "EM_ANDAMENTO", label: "Em andamento", dot: "bg-amber-400" },
  { id: "ATRASADOS", label: "Atrasados", dot: "bg-red-400" },
  { id: "CONCLUIDOS", label: "Concluídos", dot: "bg-emerald-400" },
];

/** Concluído nunca conta como atraso. */
export const noteIsLate = (note, today) =>
  note.status !== "CONCLUIDO" && note.due_date < today;

const daysUntil = (due, today) =>
  Math.round((new Date(`${due}T00:00:00`) - new Date(`${today}T00:00:00`)) / 86400000);

/** Vermelho = vencido, âmbar = prazo próximo (até 2 dias), neutro = futuro. */
export const dueTone = (note, today) => {
  if (note.status === "CONCLUIDO")
    return { badge: "bg-black/10 text-current", text: "text-muted-foreground" };
  const days = daysUntil(note.due_date, today);
  if (days < 0)
    return { badge: "bg-red-600/90 text-white", text: "text-red-400 font-medium" };
  if (days <= 2)
    return { badge: "bg-amber-600/90 text-white", text: "text-amber-400 font-medium" };
  return { badge: "bg-black/10 text-current", text: "text-muted-foreground" };
};

const sameName = (a, b) =>
  (a || "").trim().toLowerCase() === (b || "").trim().toLowerCase();

export const matchesFilter = (note, filter, today, user) => {
  switch (filter) {
    case "ABERTOS":
      return note.status !== "CONCLUIDO";
    case "MEUS":
      return note.created_by === user?.email;
    case "ATRIBUIDOS":
      return sameName(note.assignee, user?.name) || sameName(note.assignee, user?.email);
    case "ATRASADOS":
      return noteIsLate(note, today);
    case "URGENTES":
      return note.priority === "URGENTE" && note.status !== "CONCLUIDO";
    case "CONCLUIDOS":
      return note.status === "CONCLUIDO";
    default:
      return true;
  }
};
